import Vue from 'vue'
const randomColor = require('randomcolor')

Vue.mixin({
  methods: {
    generateColor(str) {
      const color = randomColor({
        seed: str
      })
      return color
    },
    hsp(color) {
      let r, g, b
      // Check the format of the color, HEX or RGB?
      if (color.match(/^rgb/)) {
        color = color.match(
            /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
        )
        r = color[1]
        g = color[2]
        b = color[3]
      } else {
        // If RGB --> Convert it to HEX: http://gist.github.com/983661
        color = +(
            '0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&')
        )
        r = color >> 16
        g = (color >> 8) & 255
        b = color & 255
      }

      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      return Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))
    },
    lightOrDark(color) {
      let hsp = this.hsp(color)

      // Using the HSP value, determine whether the color is light or dark
      if (hsp > 127.5) {
        return true
      } else {
        return false // false for dark
      }
    },

    veryLight(color) {
      let hsp = this.hsp(color)

      // Using the HSP value, determine whether the color is very light or just light
      if (hsp > 200) {
        return true //very light
      } else {
        return false //just light
      }
    },

    veryDark(color) {
      let hsp = this.hsp(color)

      // Using the HSP value, determine whether the color is very dark or just dark
      if (hsp < 50) {
        return true //very dark
      } else {
        return false //just dark
      }
    },

    getColorFor(object, index = 1) {
      if (object === 'job') {
        let nbJobColors = this.appColors.filter(c => c.slug.startsWith('color-job') && c.slug !== 'color-job-default').length
        const colorIndex = index <= nbJobColors ? index : ((index - 1) % nbJobColors) + 1;

        return this.appColors.find(c => c.slug === 'color-job-'+colorIndex)?.rgb || '#f0f0f0'
      }

      if (object === 'occupation') {
        let nbOccupationColors = this.appColors.filter(c => c.slug.startsWith('color-occupation') && c.slug !== 'color-occupation-default').length
        const colorIndex = index <= nbOccupationColors ? index : ((index - 1) % nbOccupationColors) + 1;

        return this.appColors.find(c => c.slug === 'color-occupation-'+colorIndex)?.rgb || '#f0f0f0'
      }

      if (object === 'grid') {
        let nbOccupationColors = this.appColors.filter(c => c.slug.startsWith('color-grid') && c.slug !== 'color-grid-default').length
        const colorIndex = index <= nbOccupationColors ? index : ((index - 1) % nbOccupationColors) + 1;

        return this.appColors.find(c => c.slug === 'color-grid-'+colorIndex)?.rgb || '#f0f0f0'
      }

      if (object === 'occupationSkill') {
        let nbOccupationSkillColors = this.appColors.filter(c => c.slug.startsWith('color-occupationSkill')).length
        const colorIndex = index <= nbOccupationSkillColors ? index : ((index - 1) % nbOccupationSkillColors) + 1;

        return this.appColors.find(c => c.slug === 'color-occupationSkill-'+colorIndex)?.rgb || '#f0f0f0'
      }

      if (object === 'skill') {
        return this.appColors.find(c => c.slug === 'color-cat-skill-'+(2*index-1))?.rgb || '#f0f0f0'
      }

      if (object === 'goal_status') {
        if (index === 3 || index ===4) {
          index = 1
        }
        else if (index === 2) {
          index = 3
        }
        else {
          index = 5
        }

        return this.appColors.find(c => c.slug === 'color-goal-'+(index))?.rgb || '#f0f0f0'
      }

      if (object === 'goal_status_text') {
        if (index === 3 || index ===4) {
          index = 2
        }
        else if (index === 2) {
          index = 4
        }
        else {
          index = 6
        }

        return this.appColors.find(c => c.slug === 'color-goal-'+(index))?.rgb || '#f0f0f0'
      }
    }
  }
})
